
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'

function App() {
  const handleCallClick = () => {
    window.open('tel:+1-555-VISTA-01', '_self');
  };

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      
      {/* Global Floating Call Button */}
      <button
        onClick={handleCallClick}
        className="fixed bottom-6 right-6 bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50 cursor-pointer"
        aria-label="Call VistaBoost Imaging"
      >
        <i className="ri-phone-line text-xl w-6 h-6 flex items-center justify-center"></i>
      </button>
    </BrowserRouter>
  )
}

export default App
